const cnr = {
  collectionSelect: function(){
    let collectionDropdown = document.querySelector('.collection-dropdown');
    if (collectionDropdown) {
      collectionDropdown.onclick = function() {
        collectionDropdown.classList.toggle('active');
      };
    }

    const dropdownOptions = document.querySelectorAll('.collection-dropdown .options div');
    if (dropdownOptions){
      dropdownOptions.forEach(option => {
        option.addEventListener('click', function(event) {
          event.preventDefault();

          const href = this.getAttribute('href');
          if (href) {
            const targetElement = document.getElementById(href.substring(1));
            if(targetElement) {
              const offset = 90;
              const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;

              window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
              });
            }
          }
        });
      });
    }
  },
  scrollToCollection: function(){
    const urlParams = new URLSearchParams(window.location.search);
    const scrollTarget = urlParams.get("scroll");

    const targetElement = document.getElementById('collection-' + scrollTarget);
    if(targetElement) {
      setTimeout(function(){
        const offset = 90;
        const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }, 500);
    }
  },
  destiniLocator: function(){
    setTimeout(function(){
        const locatorElement = document.getElementById('destini-locator');
        let attempts = 0;
        const maxAttempts = 12;

        const intervalId = setInterval(() => {
          attempts++;
          if (locatorElement && locatorElement.shadowRoot) {
            const styleElement = document.createElement('style');
            styleElement.textContent = `
                .chakra-button {
                    height: auto !important;
                    text-transform: uppercase;
                    border-radius: 0;
                    padding: 18px 22px 14px 16px;
                    display: flex;
                    background: var(--color-secondary);
                    color: var(--color-primary);
                    width: 100%;
                    border-radius: 5px;
                }
                .chakra-button:hover {
                    background: var(--color-secondary);
                    color: var(--color-primary);
                }
                .store-locator-btn {
                    display: flex;
                    align-items: center;  
                }
                .store-icon {
                    width: 40px;
                    margin-top: -6px;
                    margin-right: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .store-icon img {
                    width: 100%;
                    height: auto;
                }
                .store-text {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    line-height: 1;
                    font-family: var(--body-font), sans-serif;                    
                }
                .buy-online {
                    font-size: 22px;
                    font-variation-settings: "ital" 0, "wdth" 100, "wght" 700;
                    letter-spacing: 3.3px;
                }
                .find-retailer {
                    font-size: 16px;
                    letter-spacing: 1px;
                    font-variation-settings: "ital" 0, "wdth" 80, "wght" 700;
                }
                @media only screen and (min-width: 750px) and (max-width: 989px) {
                    .buy-online {
                        font-size: 23px;
                    }
                }
                @media only screen and (min-width: 990px){
                    .buy-online {
                      font-size: 22px;
                    }
                    .chakra-button {
                      max-width: 286px;
                      padding: 21px 22px 15px 16px;
                    }
                    .chakra-portal {
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    }
                }
                `;
            locatorElement.shadowRoot.appendChild(styleElement);

            const chakraButton = locatorElement.shadowRoot.querySelector('.chakra-button');
            if (chakraButton) {
              chakraButton.innerHTML = `<div class="store-locator-btn"><div class="store-icon"><img src="https://cdn.shopify.com/s/files/1/2496/7702/files/store-locator-icon.svg?v=1737659814" alt="Cart icon"></div><div class="store-text"><span class="buy-online">Buy Online</span><span class="find-retailer">or Find Local Retailers</span></div></div>`;
            }

            setTimeout(function(){
              locatorElement.classList.add('active');
            }, 500);

            clearInterval(intervalId);
          } else if (attempts >= maxAttempts) {
            clearInterval(intervalId);
          }
        }, 50);
      }, 1000);
  },
  variantSelect: function(){
    let variantDropdown = document.querySelector('.variant-dropdown');
    if (variantDropdown) {
      variantDropdown.onclick = function() {
        variantDropdown.classList.toggle('active');
      };

      const variantDropdownOptions = document.querySelectorAll('.variant-dropdown__option');

      if (variantDropdownOptions.length > 0) {
        variantDropdownOptions[variantDropdownOptions.length - 1].classList.add('last');
      }

      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');

      if (variantId) {
        const variantOption = document.querySelector(`.variant-dropdown__option[data-variant-id='${variantId}']`);

        if (variantOption) {
          const presetImage = variantOption.querySelector('.variant-dropdown__preset-image img');
          const defaultImage = document.querySelector('.variant-dropdown__default-image img');

          if (presetImage && defaultImage) {
            defaultImage.src = presetImage.src;
          }

          const presetTitle = variantOption.querySelector('.variant-dropdown__preset-title');
          const defaultTitle = document.querySelector('.variant-dropdown__default-title');

          if (presetTitle && defaultTitle) {
            defaultTitle.innerText = presetTitle.innerText;
          }
        }
      }

    }

    const variantOptions = document.querySelectorAll('.variant-dropdown .options .variant-dropdown__option');
    if (variantOptions){
      variantOptions.forEach(option => {
        option.addEventListener('click', function(event) {
          event.preventDefault();

          const presetName = this.querySelector('.variant-dropdown__preset-title').innerText;
          if (presetName){
            document.querySelector('.variant-dropdown__preset-title').innerText = presetName;
          }

          const variantImage = this.querySelector('.variant-dropdown__preset-image img').getAttribute('src');
          if (variantImage){
            document.querySelector('.variant-dropdown__preset .variant-dropdown__preset-image img').setAttribute('src', variantImage);
          }

          if (document.querySelector('.variant-dropdown__option.first')){
            document.querySelector('.variant-dropdown__option.first').style.display = 'flex';
          }
        });
      });
    }
  },
  variantButtons: function(){
    const variantButtons = document.querySelectorAll('.variant-dropdown__button');
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');

    variantButtons.forEach(button => {
      button.addEventListener('click', function() {
        variantButtons.forEach(btn => {
          btn.classList.remove('active');
        });
        this.classList.add('active');

        const variantId = this.getAttribute("data-variant-id");
        if (variantId) {
          document.querySelector('.variant-selector__buttons.desktop-only').classList.add('click-blocked');
          document.querySelector('#destini-locator').classList.add('click-blocked');
          const url = new URL(window.location.href);
          url.searchParams.set("variant", variantId);
          window.location.href = url.toString();
        }
      });
    });

    if (variantId) {
      const buttons = document.querySelectorAll('.variant-dropdown__button');
      buttons.forEach(button => {
        if (button.getAttribute('data-variant-id') === variantId) {
          button.classList.add('active');
        } else {
          button.classList.remove('active');
        }
      });
    }
  },
  homeSlider: function(){
    const slides = document.getElementsByClassName("home-hero__slide");

    if (slides.length === 1) {
      const style = document.createElement("style");
      style.type = "text/css";
      style.innerHTML = ".home-hero__slider .slick-dots { visibility: hidden !important; }";
      document.head.appendChild(style);
    }
  },
  scrollToNutrition: function(){
    const nutritionalButton = document.getElementById('nutritional-info');
    const nutritionalSection = document.querySelector('.product-nutrition');

    if (nutritionalButton && nutritionalSection) {
      nutritionalButton.addEventListener('click', function(event) {
        event.preventDefault();

        const offset = 100;
        const targetPosition = nutritionalSection.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      });
    }
  },
  productReviews: function(){
    document.querySelectorAll('[id*="bazaarvoice_reviews_photos_reviews"]').forEach(element => {
      let pdpReviewsWrapper = element.parentElement?.parentElement;
      if (pdpReviewsWrapper) {
        pdpReviewsWrapper.classList.add('pdp-reviews-module');
      }

      const checkReviewsShadowRoot = setInterval(() => {
        const pdpModule = document.querySelector('div[data-bv-show="reviews"]');

        if (pdpModule && pdpModule.shadowRoot) {
          clearInterval(checkReviewsShadowRoot);

          const style = document.createElement('style');
          style.textContent = `
            div, h1, h2, h3, h4, h5, span, p, a, li, ul, ol, .YmGNR, input {
                font-family: 'obviously-variable', sans-serif !important;
            }
            
            h1, h2, h3, h4, h5, h6, p, a, li, ul, ol, .YmGNR, input {
                color: #002854 !important;
            }
            
            .GIlyC button {
                font-family: 'obviously-variable', sans-serif !important;
            }
            
            .bbDOkP, .hzcvRM, .eDUEUZ {
              border: none !important;
            }
            
            .embnVs {
              padding-top: 40px !important;
            }
            
            .jNALof {
              padding-bottom: 50px; 
            } 
           
            h2 {
              color: #002854 !important;
              font-size: 36px !important;
              font-variation-settings: "ital" 0, "wdth" 100, "wght" 600 !important;
              text-align: center !important;
              text-transform: uppercase !important;
              margin: 16px auto 34px !important;
            }
            
            h3 {
              font-size: 24px !important;
              line-height: 28px !important;
              font-variation-settings: "ital" 0, "wdth" 100, "wght" 600 !important;
              text-transform: uppercase !important;
            }
            
            [data-bv-v="contentSummary"] div {
              line-height: 20px !important;
            }
            
            .bQReDy, .LinHZ, .grIvDi {
              background: #E9E6DF !important;
            }
            
            .jQjdgu {
              align-items: center !important;
              justify-content: center !important;
              flex-direction: column !important;
            }
            
            .duUBZt {
              text-align: center !important;
              align-items: center !important;
              justify-content: center !important;
              margin: auto !important;
            }
            
            .gTTKHN {
              padding-inline-start: 0 !important;
            }
            
            .hgrRzv {
              white-space: break-spaces !important;
              font-size: 19px !important;
            }
            
            .bv-rnr__sc-16j1lpy-4 {
              font-family: 'obviously-variable', sans-serif !important;
            }
            
            .crWzJx, .cGDaVv {
              border-bottom: none !important;
              background-color: transparent !important;
            }
            
            .crWzJx {
              margin-top: 24px;
              margin-bottom: 40px;
            }
            
            .fKQLUk path, .khLMdD path {
              stroke: #002854 !important;
            }
            
            @media only screen and (min-width: 1025px){
              h2 {
                font-size: 90px !important;
                line-height: 90px !important;
                margin-top: 0 !important;
              }
              
              h3 {
                font-size: 28px !important;
                line-height: 36px !important;
              }
              
              .jQjdgu {
                  margin-top: 70px !important;
              }
              
              .hgrRzv {
                font-size: 24px !important;
              }
            }
        `;

          pdpModule.shadowRoot.appendChild(style);
        }
      }, 500);

    });
  },
  storeLocator: function(){
    const locatorElement = document.getElementById("destini-locator");
    const body = document.body;

    if (locatorElement) {
      locatorElement.addEventListener("click", function (event) {
        body.classList.add("destini-open");
        event.stopPropagation();
      });

      document.addEventListener("click", function (event) {
        const shadowRoot = locatorElement.shadowRoot;

        if (shadowRoot) {
          if (!shadowRoot.contains(event.target) && !locatorElement.contains(event.target)) {
            body.classList.remove("destini-open");
          }
        } else {
          if (!locatorElement.contains(event.target)) {
            body.classList.remove("destini-open");
          }
        }
      });
    }
  },
  searchBar: function(){
    const searchIcon = document.querySelector(".header__icon.header__icon--search");
    const body = document.body;

    if (searchIcon) {
      searchIcon.addEventListener("click", function (event) {
        body.classList.add("search-open");
      });
    }

    document.addEventListener("click", function (event) {
      const searchModal = document.querySelector(".search-modal");

      if (!searchModal.contains(event.target) && !searchIcon.contains(event.target)) {
        body.classList.remove("search-open");
      }
    });
  },
  faqs: function(){
    const faqItems = document.querySelectorAll('.section-faqs .faq-item button');

    function toggleActive(event) {
      const index = this.parentNode.getAttribute('data-index');
      if (document.querySelector('.faq-item[data-index="'+ index + '"]').classList.contains('active')){
        document.querySelector('.faq-item[data-index="'+ index + '"]').classList.remove('active');
      }
      else {
        document.querySelector('.faq-item[data-index="'+ index + '"]').classList.add('active');
      }
    }

    faqItems.forEach(function (item) {
      item.addEventListener('click', toggleActive);
    });
  },
  scrollToReviews: function(){
    const ratingWrapper = document.querySelector(".rating-wrapper-bv");
    const reviewsSection = document.querySelector('div[data-bv-show="reviews"]');

    if (ratingWrapper && reviewsSection) {
      ratingWrapper.addEventListener("click", function (event) {
        event.preventDefault();

        reviewsSection.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  cnr.searchBar();

  /** Index **/
  if (document.body.classList.contains('index')) {
    cnr.homeSlider();
  }

  /** Collection **/
  if (document.body.classList.contains('collection')) {
    cnr.collectionSelect();
    cnr.scrollToCollection();
  }

  /** PDP **/
  if (document.body.classList.contains('product')) {
    cnr.destiniLocator();
    cnr.variantSelect();
    cnr.scrollToNutrition();
    cnr.productReviews();
    cnr.storeLocator();
    cnr.scrollToReviews();
  }

  if (document.querySelector('.section-faqs')) {
    cnr.faqs();
  }
  });


/** Sliders */
$(document).ready(function() {
  const $sliders = {
    homeHero: $('.home-hero__slider'),
    product: $('.product-slider__slides'),
    press: $('.press-quotes__slider'),
    careers: $('.image-slider-text__slides')
  };

  if ($sliders.homeHero.length > 0) {
    $sliders.homeHero.slick({
      infinite: false,
      dots: true,
      centerMode: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false
    });
  }

  if ($sliders.careers.length > 0) {
    $sliders.careers.slick({
      infinite: true,
      dots: true,
      centerMode: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false
    });
  }

  if ($sliders.product.length > 0) {
    $sliders.product.slick({
      dots: false,
      centerMode: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      infinite: false,
      arrows: false,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '60px'
          }
        }
      ]
    });
  }

  if ($sliders.press.length > 0) {
    $sliders.press.slick({
      dots: false,
      centerMode: true,
      centerPadding: '490px',
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            centerPadding: '400px'
          }
        },
        {
          breakpoint: 1200,
          settings: {
            centerPadding: '200px'
          }
        },
        {
          breakpoint: 990,
          settings: {
            centerPadding: '60px'
          }
        }
      ]
    });
  }
});